import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { Table } from "../../../../../../Shared/Table/Table";

interface IAssetsToSellTableProps {
    existingData: InvestmentAllocation[];
    tableData: InvestmentAllocation[];
    title?: string;
}

interface IAssetsToSellTableState {}

export class AssetsToSellTable extends FormComponent<IAssetsToSellTableProps, IAssetsToSellTableState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { existingData, tableData, title } = this.props;
        const total = existingData
            ? existingData.reduce((sum, curr) => {
                  return (sum = sum + curr.Percentage);
              }, 0)
            : [];

        
        return (
            <>
                <h2 className="mt-48">{title || "Disinvest selection"}</h2>
                <Table
                    data={tableData}
                    col={[
                        {
                            title: "Investments",
                            key: "Name",
                            render: (data, row, index) => {
                                return <a className="hyper-link">{data}</a>;
                            },
                        },
                        {
                            title: "Existing allocation",
                            key: "Id",
                            render: (data, row, index) => {
                                const percentage = this.getExistingAllocation(row.ProductId);
                                return <span>{percentage}</span>;
                            },
                        },
                        {
                            title: "New allocation",
                            key: "Percentage",
                        },
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 2 },
                        { data: <span className={total == 100 ? "text-positive" : "text-text"}>{total}%</span> },
                    ]}
                />
            </>
        );
    }

    private getExistingAllocation(id) {
        if (!isNullOrEmpty(this.props.existingData)) {
            const match = this.props.existingData.find((data) => data.ProductId === id);
            return match ? match.Percentage : "-"
        } else {
            return "Proportional";
        }
    }
}
